import type { Components } from '@mui/material/styles';

export default function MUIBottomNavigationAction(): Components['MuiBottomNavigationAction'] {
  return {};
}
